import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: "#292720",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#a68757",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f6f4ef",
      paper: "#ffffff",
    },
    text: {
      primary: "#292720",
      secondary: "#706d64",
    },
  },
  typography: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
    h2: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
    h3: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
    h4: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
  },
  listItemText: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
  },
  CardHeader: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
  },
  shape: {
    borderRadius: 2,
  },
});

export default responsiveFontSizes(theme);